import { FaMinus, FaPlus } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldName, useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 CONTADOR — cantidad con menos y más

    El input central acepta escritura directa, pero se recorta a los
    límites al salir del campo: si escribís 999 con max 10, vuelve a 10.
*/

export const FieldCounter = ({
    id, name, label, hint, error,
    value = 0, onChange,
    min = 0, max = 99, step = 1,
    isDisabled = false, span = 1,
}) => {

    const NUM = Number(value) || 0;

    const onSet = (next) => onChange?.(Math.min(max, Math.max(min, next)));

    const DOM_NAME = useDomFieldName();

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
            isDisabled={isDisabled} span={span} >

            <div className={`${BLOCK}__counter`}>

                <button type="button" className={`${BLOCK}__counter_button`}
                    aria-label="Restar" disabled={isDisabled || NUM <= min}
                    onClick={() => onSet(NUM - step)} >
                    <FaMinus />
                </button>

                <input id={DOM_ID} data-field={name ?? id} name={DOM_NAME} type="text" inputMode="numeric"
                    className={`${BLOCK}__counter_input`}
                    value={NUM} disabled={isDisabled}
                    onChange={(event) => onChange?.(event.target.value.replace(/\D/g, ''))}
                    onBlur={() => onSet(NUM)} />

                <button type="button" className={`${BLOCK}__counter_button`}
                    aria-label="Sumar" disabled={isDisabled || NUM >= max}
                    onClick={() => onSet(NUM + step)} >
                    <FaPlus />
                </button>

            </div>

        </FieldShell>
    );
};
